import React from "react";
import { serverConstants } from "Shared/Constants";

export function MainFooter() {
  return (
    <footer
      className="footer has-text-centered"
      id="footer"
      style={{
        flex: 1,
        flexGrow: 1,
        paddingTop: "30px",
        paddingBottom: "30px",
        backgroundColor: "#f6f6f4",
      }}
    >
      <img
        alt={serverConstants.CompanyName}
        src="/img/Logos/levelesq-logo-color-01.svg"
        style={{
          maxHeight: "66px",
        }}
      />
      <FooterLink
        href="tel:1-833-905-3835"
        title="1 (833) 90 LEVEL"
        style={{ fontWeight: 900 }}
      />
      <FooterLink
        href={`mailto:${serverConstants.AdminEmail}`}
        title={serverConstants.AdminEmail}
      />
      <FooterLink href="https://www.facebook.com/levelesq" title="Facebook" />
      <FooterLink
        href="https://www.instagram.com/level_esq"
        title="Instagram"
      />
      <FooterLink
        href="https://www.linkedin.com/company/levelesq"
        title="LinkedIn"
      />
      <FooterLink href="https://twitter.com/levelesq" title="Twitter" />
    </footer>
  );
}

function FooterLink(props: {
  href: string;
  title: string;
  style?: React.CSSProperties;
}) {
  return (
    <h3 itemProp="headline">
      <a
        href={props.href}
        title={props.title}
        style={{
          fontSize: "20px",
          color: "rgba(0,0,0,.54)",
        }}
      >
        <strong style={props.style}>{props.title}</strong>
      </a>
    </h3>
  );
}
